import { forIn, join, replace } from 'lodash';

export const getPath = (pathname: string | string[], params?: Record<string, unknown>) => {
  let newPath = '';

  if (typeof pathname === 'object') {
    newPath = join(pathname, '');
  } else {
    newPath = pathname;
  }

  if (params) {
    forIn(params, (value, key) => {
      newPath = replace(newPath, `:${key}`, value as string);
    });
  }

  if (newPath.includes(':')) {
    throw new Error(`route's url isn't provided params at ${newPath}`);
  }

  return newPath;
};

export const getRoute = (pathname: string | string[]) => {
  let newPath = '';

  if (typeof pathname === 'object') {
    newPath = join(pathname, '');
  } else {
    newPath = pathname;
  }

  return newPath;
};
